import { machineryIcon } from 'assets/icons/MachineryIcon'
import { EmptyList } from 'components/Table/EmptyList'
import { Box, Flex } from 'styling/GlobalStyles'
import { BigText, ColorVariant, Heading2, MediumText } from 'styling/TypographyV2'
import { ProcurementPurchaseOrderResponse } from 'types/procurement/purchaseOrder.model'

export const OpenPurchaseOrder = ({
  purchaseOrders,
}: {
  purchaseOrders: ProcurementPurchaseOrderResponse[]
}) => {
  return (
    <Box>
      <Flex center gap='8px'>
        {machineryIcon}
        <Heading2>Open Purchase Order</Heading2>
      </Flex>
      <Flex mt='20' gap='16px' column>
        {purchaseOrders.length > 0 ? (
          purchaseOrders.map((purchaseOrder) => (
            <OpenPurchaseOrderCard key={purchaseOrder.id} purchaseOrder={purchaseOrder} />
          ))
        ) : (
          <EmptyList title='No open purchase orders' description='No open purchase orders' />
        )}
      </Flex>
    </Box>
  )
}

const OpenPurchaseOrderCard = ({
  purchaseOrder,
}: {
  purchaseOrder: ProcurementPurchaseOrderResponse
}) => {
  return (
    <Box width='100%'>
      <Flex column gap='8px'>
        <Flex between>
          <MediumText colorVariant={ColorVariant.SECONDARY}>
            PR - {new Date(purchaseOrder.createdAt).getFullYear()} - {purchaseOrder.id}
          </MediumText>
          <MediumText colorVariant={ColorVariant.SECONDARY}>
            {purchaseOrder.items.reduce((acc, item) => acc + (item.receivedQuantity || 0), 0)}/
            {purchaseOrder.items.reduce(
              (acc, item) => acc + (item.procurementPurchaseRequestItem.quantity || 0),
              0,
            )}{' '}
            Received
          </MediumText>
        </Flex>
        <Flex between>
          <Heading2>{purchaseOrder.procurementPurchaseRequest?.title}</Heading2>
          <BigText>
            {purchaseOrder.procurementPurchaseRequest?.selectedQuote?.items.reduce(
              (acc, item) => acc + item.price,
              0,
            ) || '0'}{' '}
            {purchaseOrder.procurementPurchaseRequest?.selectedQuote?.currency}
          </BigText>
        </Flex>
      </Flex>
    </Box>
  )
}
